import { inject } from 'vue';
import type { FeatureFlagService, FlagName } from '@/contracts/FeatureFlagService';

// Thin convenience wrapper so call sites read `useFlag('X')` instead of
// `(inject('featureFlags') as FeatureFlagService).isEnabled('X')` — typed to
// FlagName so a typo'd flag name fails at compile time, not silently-false.
//
// Only safe to call from a composable or component's setup() — anywhere
// Vue's injection context is active. Not from a plain class method or
// module-level code: inject() has nothing to resolve there, and this
// throws rather than silently misbehaving.
export function useFlag(flag: FlagName): boolean {
	const featureFlags = inject('featureFlags') as FeatureFlagService | undefined;

	if (!featureFlags) {
		throw new Error('useFlag(): no featureFlags provider found — call this from a composable or component setup() under a provider (main.ts in production), not a plain class method, module-level code, or a test mount with no provide.');
	}

	return featureFlags.isEnabled(flag);
}
